import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { Growl } from 'angular/custom/services/growl.service';

class BalancingGroupPortfolioCodeSelectionSettingsComponentCtrl
    implements ng.IController
{
    private enabledSettings: PossibleSettings[];
    public requireBalancingGroupForTransferOfUseTrades: boolean;
    public selectionBiddingST: SelectionPossibility;
    public selectionBiddingLT: SelectionPossibility;
    public selectionSecondaryST: SelectionPossibility;
    public selectionSecondaryLT: SelectionPossibility;
    public selectionSurrenderST: SelectionPossibility;
    public selectionSurrenderLT: SelectionPossibility;
    public selectionForUpgradeLT: SelectionPossibility;
    public selectionForUpgradeST: SelectionPossibility;
    public selectionFcfsST: SelectionPossibility;
    public selectionFcfsLT: SelectionPossibility;
    public selectionForFlowCommitmentForReverseAuction: SelectionPossibility;
    public selectionForBuyBackForReverseAuction: SelectionPossibility;
    public isBalancingGroup: boolean;
    public tsoRefId: number;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private errorHandler: ErrorHandler,
        private growl: Growl
    ) {}

    $onInit() {}

    public saveRequireBalancingGroupForTransferOfUseTrades() {
        this.TransmissionSystemOperator.saveRequireBalancingGroupForTransferOfUseTrades(
            { id: this.tsoRefId },
            this.requireBalancingGroupForTransferOfUseTrades,
            (res) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            (err) => {
                this.requireBalancingGroupForTransferOfUseTrades =
                    !this.requireBalancingGroupForTransferOfUseTrades;
                this.errorHandler(err);
            }
        );
    }
}

angular
    .module('app')
    .component('pkpBalancingGroupPortfolioCodeSelectionSettings', {
        controller: BalancingGroupPortfolioCodeSelectionSettingsComponentCtrl,
        template:
            require('app/operator-settings-general/balancing-group-portfolio-code-selection-settings.component.html'),
        bindings: {
            tsoRefId: '=',
            selectionBiddingST: '=',
            selectionBiddingLT: '=',
            selectionSecondaryST: '=',
            selectionSecondaryLT: '=',
            selectionSurrenderST: '=',
            selectionSurrenderLT: '=',
            selectionForUpgradeLT: '=',
            selectionForUpgradeST: '=',
            selectionFcfsST: '=',
            selectionFcfsLT: '=',
            selectionForFlowCommitmentForReverseAuction: '=',
            selectionForBuyBackForReverseAuction: '=',
            isBalancingGroup: '=',
            requireBalancingGroupForTransferOfUseTrades: '=',
            enabledSettings: '<'
        }
    });
